/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkoutB2B = {
  checkoutB2B: {
    noPoNumber: 'Ninguno',
    poNumber: 'Número de orden de compra (opcional)',
    costCenter: 'Centro de costos',
    placeholder: 'Introduzca P.O',
    availableLabel:
      "Las direcciones de entrega disponibles dependen de la unidad del centro de coste",
    invalid: {
      accountType: 'Su cuenta no le permite pagar aquí.',
    },
    methodOfPayment: {
      paymentType: 'Tipo de pago',
    },
    review: {
      poNumber: 'Número de orden de compra',
    },
    progress: {
      methodOfPayment: 'Forma de pago',
    },
    invalidCostCenter: 'Centro de coste no válido.',
  },
};
